// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-multi-adJM04{position:relative}.wrapper-multi-adJM04 .semi-sidesheet.semi-sidesheet-popup{z-index:100}.wrapper-single-BQ0i4v{flex:1;grid-template-columns:auto minmax(0,1fr);display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper-multi": `wrapper-multi-adJM04`,
	"wrapperMulti": `wrapper-multi-adJM04`,
	"wrapper-single": `wrapper-single-BQ0i4v`,
	"wrapperSingle": `wrapper-single-BQ0i4v`
};
export default ___CSS_LOADER_EXPORT___;
